import React from "react"
import { Box, CircularProgress, Stack, Typography } from "@mui/material"
import DialogBox from "../../../core-components/theme/components/DialogBox/DialogBox"
import ButtonStack from "../../../globalComponents/buttonStack"
import { Neutrals, Primary } from "../../../core-components/theme/color-palette/colors"
import useFMUploadFiles from "../hooks/useFMUploadFiles"
import SelectedFiles from "../FMListing/SelectedFiles"
import FileUploadComponent from "../../../globalComponents/FileUploadComponent"
import { ALLOWED_MIME_TYPES } from "../helper"
import Button from "../../../core-components/theme/components/Button/Button"
import AddIcon from '@mui/icons-material/Add';
import FMFileViewer from "./FMFileViwer"
import { FileWithMetaType, UploadFMFilesDialogInterface } from "../types"
import FMSFileConflictDialog from "./FMSFileConflictDialog"

const UploadFMFilesDialog = ({handleClose, queryKeyData}: UploadFMFilesDialogInterface) => {
  const {selectedFilesCollection, handleSave, handleDelete, handleFileSelection, handleSelectChange, validateSelectedFiles, handleAddMoreClick, isTableAndAbove, addMoreInputRef, selectedFileForPreview, handleSelectPreview, handleCloseFileViewer, showConflictDialog, handleConflictDialogClose, isUploading} = useFMUploadFiles({queryKeyData, handleClose});
  
  return (
    <DialogBox width="100%" maxWidth="860px" minHeight="160px" open={true} onClose={() => !isUploading && handleClose()} title="" dialogStyles={{paddingLeft: '18px', margin: '16px'}}>
      <Stack spacing={5}>
        {
          selectedFilesCollection?.length < 1 ?
          <FileUploadComponent 
            onFileClick={handleFileSelection} 
            buttonProps={{sx: {maxWidth: '164px', fontSize: '14px', textTransform: 'unset'}}} 
            stackProps={{sx: {alignItems: 'center', rowGap: 3}}}
            multiple={true}
            accept={ALLOWED_MIME_TYPES.join(',')}
          /> :
          <React.Fragment>
            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} columnGap={3}>
              <Typography variant="body1" sx={{fontSize: 20, fontWeight: 500}}>Organize Documents</Typography>
               <>
                <input
                  type="file"
                  multiple={true}
                  accept={ALLOWED_MIME_TYPES.join(',')}
                  ref={addMoreInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileSelection}
                />
                <Button variant="outlined" onClick={handleAddMoreClick}>
                  {
                    isTableAndAbove &&
                    <Typography variant='body1' sx={{marginRight: '5px'}}>ADD</Typography>
                  }
                  <AddIcon sx={{ color: Primary[900] }} fontSize="small" />
                </Button>
              </>
            </Stack>
            {
              selectedFilesCollection.map((fileObj: FileWithMetaType, index: number) => (
                <SelectedFiles key={index} index={index} fileObj={fileObj} handleDelete={handleDelete} handleSelectChange={handleSelectChange} handleSelectPreview={handleSelectPreview} />
              ))
            }
          </React.Fragment>
        }
        {
          selectedFilesCollection?.length > 0 &&
          <ButtonStack
            containerProps={{ spacing: 3, direction: "row", alignItems: "center", justifyContent: "flex-end" }}
            cancelButtonProps={{
              sx: {
                border: `1px solid ${Neutrals[500]}`,
                borderRadius: '4px',
                backgroundColor: 'white',
                color: `${Neutrals[500]}`,
                boxShadow: 'none',
                ':hover': { background: 'none', boxShadow: 'none' },
              },
              disabled: isUploading
            }}
            saveButtonProps={{
              disabled: validateSelectedFiles || (!showConflictDialog && isUploading),
            }}
            saveLabel={(!showConflictDialog &&isUploading) ? <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>Uploading <CircularProgress size={20} sx={{  color: 'white'}}/></Box> : "Submit"}
            onSave={() => handleSave()}
            onCancel={handleClose}
          />
        }
      </Stack>
      {
        selectedFileForPreview &&
        <FMFileViewer
          fileUrl={selectedFileForPreview?.fileUrl}
          mimeType={selectedFileForPreview?.fileType}
          fileName={selectedFileForPreview?.fileName}
          handleClose={handleCloseFileViewer}
         />
      }
      {
        showConflictDialog &&
        <FMSFileConflictDialog filesCollection={selectedFilesCollection} handleClose={handleConflictDialogClose} handleFileConflictStatus={(mode: string) => handleSave(mode)} isLoading={isUploading} />
      }
    </DialogBox>
  )
}

export default UploadFMFilesDialog;